import React from 'react'

const RegisterHeaderField = ({title, data}) => {
  return (
    <div className='register-header-field'>
      <div className='title'>{title}</div>
      <div className='data'>{data}</div>
    </div>
  )
}

export default RegisterHeaderField
